import angular from 'angular';
import treatAdminListComponent from './treat-admin-list.component';

export default angular.module('components.app.product.treatAdminList', [])
  .component('treatAdminList', treatAdminListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/treat-admin-list/treat-admin-list.module.js